import { Stack, Typography } from '@mui/material';
import { subDays } from 'date-fns';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { useEffect } from 'react';
import BalancesGallery from 'sections/dashboard/BalancesGallery';
import Articles from 'components/Articles/Articles';
import RecentsGallery from 'sections/dashboard/RecentsGallery';
import { getActivitiesAsync } from 'services/activity.services';
import { getOpenPendingRequestsByCompanyId } from 'services/requests.services';
import { getUserDetails } from 'state/reducers/user.reducers';
import { getCurrencyCode, getCurrencyRange } from 'state/reducers/currency-rate.reducers';
import { selectLanguage, selectTranslations } from 'state/reducers/translation.reducers';
import { getUserName } from 'utils';
import { getBalancesByCompanyId } from 'services/balance.services';

export default function Dashboard() {
  const currency = useAppSelector(getCurrencyCode);
  const range = useAppSelector(getCurrencyRange);
  const user = useAppSelector(getUserDetails);
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);
  //const loading = useAppSelector(loadingActivities).loadingActivities;
  const { firstName, firstNameHebrew } = useAppSelector(getUserDetails);
  const selectedLanguage = useAppSelector(selectLanguage);

  useEffect(() => {
    dispatch(getActivitiesAsync(user?.companyId, new Date(), new Date(), 5));
    dispatch(getOpenPendingRequestsByCompanyId());
  }, []);

  useEffect(() => {
    //dispatch(getCurrencyRates(currency,range))
  }, [currency, range]);

  return (
    <Stack spacing={4}>
      <Typography variant="h4">
        {t('page.dashboard.welcome.text')} {getUserName(firstName, firstNameHebrew, selectedLanguage)}
      </Typography>
      <BalancesGallery />
      {/*!isMobile && <GraphGallery/>*/}
      <RecentsGallery />
      <Articles theme='green' />
    </Stack>
  );
}
